

//Data imports
import AccessMatrix from '@/router/access-matrix';
import LicenseKeys from "@/helpers/Constants/LicenseKeys";

//View and component imports
import RouteListItem_Contractlists from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_ContractLists.vue";
import Title_ContractLists from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_ContractLists.vue";
import Title_Contract from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Contract.vue";
import SubMenuTab_ContractOrders from "@/components/SingleUse/ComponentOverrides/submenu/SubMenuTab_ContractOrders.vue";
//import PlannedConstruction from '@/views/landingpages/PlannedConstruction.vue';
const OldGuiFrame = () => import('@/views/landingpages/OldGuiFrame.vue')

const RouterView = () => import('@/views/landingpages/RouterView.vue')
//const ServiceAgreements = IsProd ? PlannedConstruction : () => import('@/views/admin/machines/AdminServiceAgreements.vue');
//contracts
const ContractLicenceRedirect = () => import('@/views/contracts/ContractLicenceRedirect.vue');
const Contracts = () => import('@/views/contracts/AdminContractList.vue');
const ViewContractContainer = () => import("@/views/contracts/ViewContractContainer.vue");
const ViewContractInfo = () => import("@/views/contracts/ViewContractInfo.vue");
const ViewContractDetails = () => import('@/views/contracts/ViewContractDetails.vue');
const ViewContractOrders = () => import('@/views/contracts/ViewContractOrders.vue');
const ViewContractResources = () => import('@/views/contracts/ViewContractResources.vue');
const ViewContractPriceUpdate = () => import('@/views/contracts/ContractDetailPriceUpdate.vue');
const NextOrders = () => import('@/views/contracts/NextOrders.vue');

//Export item
const trunk = {
  meta: {
    licenseEnabled: `${LicenseKeys.Quotation},${LicenseKeys.Contract}`,
    authorize: AccessMatrix.ContractsTrunk.module,
    display: { key: "servicesystem.pages.page_titles.sales" },
    icon: "mdi-file-delimited",
  },
  path: '/sales',
  name: 'SalesModule',
  component: RouterView,
  redirect: { name: 'ContractLicenceRedirect' },
  children: [
    {
      meta: {
        authorize: AccessMatrix.ContractsTrunk.module,
        display: 'Redirect',
        icon: "mdi-directions-fork",
        overrides: {
          sidebar: false,
        }
      },
      path: '',
      name: 'ContractLicenceRedirect',
      component: ContractLicenceRedirect,
    },
    /*
    {
      meta: {
        authorize: AccessMatrix.ContractsTrunk.module,
        display: { key: "servicesystem.pages.page_titles.admin_service_agreements" },
        icon: "mdi-file-clock",
      },
      path: 'service-agreements',
      name: 'ServiceAgreements',
      component: ServiceAgreements,
    },
    */
    {
      meta: {
        authorize: AccessMatrix.ContractsTrunk.module,
        display: { key: "servicesystem.pages.page_titles.contracts" },
        icon: "mdi-receipt-text-clock",
        overrides: {
          sidebar: RouteListItem_Contractlists,
          title: Title_ContractLists,
          header: {
            buttons: ['NewDialogTriggerBtn'],
          },
        }
      },
      path: 'contracts/:contractTypeId',
      name: 'Contracts',
      component: Contracts,
      children: [
        {
          meta: {
            licenseEnabled: LicenseKeys.Contract,
            authorize: AccessMatrix.ContractsTrunk.module,
            display: 'View Contract',
            icon: "mdi-text-box-search-outline",
          },
          path: 'old/:contractId',
          name: 'OldContractView',
          component: OldGuiFrame,
        },
      
        //Draft 
        {
          meta: {
            licenseEnabled: `${LicenseKeys.Quotation},${LicenseKeys.Contract}`,
            authorize: AccessMatrix.ContractsTrunk.module,
            overrides: {
              sidebar: false,
              title: Title_Contract,
            },
            contextMenu: true
          },
          path: 'draft/:contractId',
          name: "ViewDraft",
          component: ViewContractContainer,
          redirect: { name: "ViewDraftInfo" },
          children: [
            {
              meta: {
                licenseEnabled: `${LicenseKeys.Quotation},${LicenseKeys.Contract}`,
                authorize: AccessMatrix.ContractsTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.info" },
                icon: "mdi-home",
              },
              path: "info",
              name: "ViewDraftInfo",
              component: ViewContractInfo
            },
            {
              meta: {
                licenseEnabled: `${LicenseKeys.Quotation},${LicenseKeys.Contract}`,
                authorize: AccessMatrix.ContractsTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.details" },
                icon: "mdi-format-list-group",
              },
              path: "details",
              name: "ViewDraftDetails",
              component: ViewContractDetails
            },
            {
              meta: {
                licenseEnabled: `${LicenseKeys.Quotation},${LicenseKeys.Contract}`,
                authorize: AccessMatrix.ContractsTrunk.module,
                display: { key: "servicesystem.common_objects.document.resources" },
                icon: "mdi-folder-open",
              },
              path: "resources",
              name: "ViewDraftResources",
              component: ViewContractResources
            },
          ]
        },

        //Quotation  
        {
          meta: {
            licenseEnabled: LicenseKeys.Quotation,
            authorize: AccessMatrix.ContractsTrunk.module,
            overrides: {
              sidebar: false,
              title: Title_Contract,
            },
            contextMenu: true
          },
          path: 'quotation/:contractId',
          name: "ViewQuotation",
          component: ViewContractContainer,
          redirect: { name: "ViewQuotationInfo" },
          children: [
            {
              meta: {
                licenseEnabled: LicenseKeys.Quotation,
                authorize: AccessMatrix.ContractsTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.info" },
                icon: "mdi-home",
              },
              path: "info",
              name: "ViewQuotationInfo",
              component: ViewContractInfo
            },
            {
              meta: {
                licenseEnabled: LicenseKeys.Quotation,
                authorize: AccessMatrix.ContractsTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.details" },
                icon: "mdi-format-list-group",
              },
              path: "details",
              name: "ViewQuotationDetails",
              component: ViewContractDetails
            },
            {
              meta: {
                licenseEnabled: LicenseKeys.Quotation,
                authorize: AccessMatrix.ContractsTrunk.module,
                display: { key: "servicesystem.common_objects.document.resources" },
                icon: "mdi-folder-open",
              },
              path: "resources",
              name: "ViewQuotationResources",
              component: ViewContractResources
            },
          ]
        },

        //Regular contract (monthly billing)
        {
          meta: {
            licenseEnabled: LicenseKeys.Contract,
            authorize: AccessMatrix.ContractsTrunk.module,
            overrides: {
              sidebar: false,
              title: Title_Contract,
            },
            contextMenu: true
          },
          path: 'contract/:contractId',
          name: "ViewContract",
          component: ViewContractContainer,
          redirect: { name: "ViewContractInfo" },
          children: [
            {
              meta: {
                licenseEnabled: LicenseKeys.Contract,
                authorize: AccessMatrix.ContractsTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.info" },
                icon: "mdi-home",
                overrides: {
                  header: {
                    buttons: ['ToggleContractActiveBtn'],
                  },
                },
              },
              path: "info",
              name: "ViewContractInfo",
              component: ViewContractInfo
            },
            {
              meta: {
                licenseEnabled: LicenseKeys.Contract,
                authorize: AccessMatrix.ContractsTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.details" },
                icon: "mdi-format-list-group",
                overrides: {
                  header: {
                    buttons: ['NewDialogTriggerBtn'],
                  },
                },
              },
              path: "details",
              name: "ViewContractDetails",
              component: ViewContractDetails
            },
            {
              meta: {
                licenseEnabled: LicenseKeys.Contract,
                authorize: AccessMatrix.ContractsTrunk.module,
                display: { key: "servicesystem.common_objects.order.orders" },
                icon: "mdi-history",
                overrides: {
                  submenutab: SubMenuTab_ContractOrders,
                },
              },
              path: "orders",
              name: "ViewContractOrders",
              component: ViewContractOrders
            },
            {
              meta: {
                licenseEnabled: LicenseKeys.Contract,
                authorize: AccessMatrix.ContractsTrunk.module,
                display: { key: "servicesystem.common_objects.document.resources" },
                icon: "mdi-folder-open",
              },
              path: "resources",
              name: "ViewContractResources",
              component: ViewContractResources
            },
          ]
        },

        //Service job
        {
          meta: {
            licenseEnabled: LicenseKeys.Quotation,
            authorize: AccessMatrix.ContractsTrunk.module,
            overrides: {
              sidebar: false,
              title: Title_Contract,
            },
            contextMenu: "Hidden"
          },
          path: 'service-job/:contractId',
          name: "ViewServiceJobContract",
          component: ViewContractContainer,
          redirect: { name: "ViewServiceJobContractInfo" },
          children: [
            {
              meta: {
                licenseEnabled: LicenseKeys.Quotation,
                authorize: AccessMatrix.ContractsTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.info" },
                icon: "mdi-home",
              },
              path: "info",
              name: "ViewServiceJobContractInfo",
              component: OldGuiFrame
            },
          ]
        }
      ]
    },

    {
      meta: {
        licenseEnabled: LicenseKeys.Contract,
        authorize: AccessMatrix.ContractsTrunk.module,
        displayName: 'Next order overview',
        icon: "mdi-receipt-clock",
      },
      path: 'next-orders',
      name: 'NextOrders',
      component: NextOrders,
    },
    {
      meta: {
        licenseEnabled: LicenseKeys.Contract,
        authorize: AccessMatrix.ContractsTrunk.module,
        display: { key: "servicesystem.common_objects.contract.priceupdate" },
        icon: "mdi-receipt-clock",
      },
      path: 'price-update',
      name: 'Price update',
      component: ViewContractPriceUpdate,
    },
  ],
};

export default trunk;